import { action, observable } from 'mobx'

import Ds from './ds'

class Backends {
  @observable data = []/*[{
    id: 0,
    name: 'Loading...'
  }]*/

  @observable ds = new Ds()

  @action loadAllBackends() {
    console.log('loadAllBackends');

    let query = `{ backends(hash: "${ localStorage.getItem('userHash') }") { id name } }`
    this.ds.query(query, (data) => {
      //console.log('loadAllBackends DATA:', data);
      this.data = data.backends
    })
  }

  @action newBackend(name) {
    console.log('newBackend');
    this.ds.query(`mutation { addBackend(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllBackends()
    })
  }

  @action updateBackend(id, name) {
    console.log('updateBackend');
    this.ds.query(`mutation { updateBackend(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllBackends()
    })
  }

  @action deleteBackend(id) {
    console.log('deleteBackend');
    this.ds.query(`mutation { deleteBackend(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllBackends()
    })
  }
}

export default new Backends()



// WEBPACK FOOTER //
// ./src/stores/backends.js